import $ from 'jquery';
// import mpro from './mpro.init';

/**
 * @typedef {{ [key: string]: string }} MpIconsMap
 * @typedef {{
 * left?: string|number;
 * right?: string|number;
 * top?: string|number;
 * bottom?: string|number;
 * middle?: string|number;
 * top_bottom?: string|number;
 * left_right?: string|number;
 * center?: boolean|number;
 * size?: string;
 * format?: string;
 * class?: string | string[];
 * style?: string;
 * title?: string;
 * tooltip?: string|{ text: string; position?: string; }|boolean;
 * }} IconOptions
 */

/** @type {MpIconsMap} */
let iconsMapCache;

/**
 * Get translation data from dom
 */
const getIconsMap = () => {

	if (!iconsMapCache) {

		const jsonSelector = mpro.config.ui.icons_map_selector;

		try {
			iconsMapCache = JSON.parse($(jsonSelector).text());
		}
		catch {
			console.warn('No icons map data could be obtained from DOM using selector: %o', jsonSelector);
			iconsMapCache = {};
		}
	}

	return iconsMapCache;
};

/**
 * Find icons in a container
 *
 * @param {JQuery<HTMLElement>} $container
 */
mpro.findIcons = ($container) => {
	return $container.find(mpro.config.ui.icons_selector);
};

/**
 * Replace icon in place
 *
 * @param {JQuery<HTMLElement>} $icon
 * @param {string} type
 */
mpro.replaceIcon = ($icon, type) => {

	if (!$icon?.length) {
		return $icon;
	}

	const iconsMap = getIconsMap();
	const classList = [
		iconsMap[type] || `mdi mdi-${type}`,
	];

	// Remove mdi and mdi-* class regex
	// eslint-disable-next-line unicorn/no-unsafe-regex
	$icon.attr('class', $icon.attr('class').replaceAll(/\bmdi(?:-\w+)*\b/g, '').trim().replaceAll(/\s{2,}/g, ' '));
	return $icon.addClass(classList.join(' '));
};

/**
 * Add icon in place
 *
 * @param {string} type
 * @param {IconOptions} options
 */
mpro.icon = (type, options = {}) => {

	const iconsMap = getIconsMap();
	const classList = [
		iconsMap[type] || `mdi mdi-${type}`,
	];
	const attrList = new Map();

	if (options.left) {
		classList.push(`ms-${options.left}`);
	}

	if (options.right) {
		classList.push(`me-${options.right}`);
	}

	if (options.top) {
		classList.push(`mt-${options.top}`);
	}

	if (options.bottom) {
		classList.push(`mb-${options.bottom}`);
	}

	if (options.middle) {
		classList.push(`m-${options.middle}`);
	}

	if (options.top_bottom) {
		classList.push(`my-${options.top_bottom}`);
	}

	if (options.left_right) {
		classList.push(`mx-${options.left_right}`);
	}

	if (options.center) {
		classList.push('m-auto');
	}

	// eslint-disable-next-line unicorn/explicit-length-check
	if (options.size) {
		classList.push(`icon-${options.size}`);
	}

	if (options.format) {
		classList.push(`text-${options.format}`);
	}

	if (options.class) {
		classList.push(...(Array.isArray(options.class) ? options.class : [options.class]));
	}

	if (options.style) {
		attrList.set('style', options.style);
	}

	// Icon tooltip
	if (options.tooltip) {

		const { tooltip } = options;

		if (typeof tooltip === 'string') {
			attrList.set('title', tooltip);
		}
		else if (typeof tooltip === 'object') {
			attrList.set('title', tooltip.text || options.title || '');

			if (tooltip.position) {
				attrList.set('data-bs-placement', tooltip.position);
			}
		}
		else if (tooltip === true) {
			attrList.set('title', options.title || '');
		}
	}
	// Icon title
	else if (options.title) {
		attrList.set('title', options.title);
	}

	const attrStr = [...attrList.entries()].map(([key, value]) => `${key}="${mpro.Sanitize.attr(value)}"`).join(' ');

	return '<i class="' + classList.join(' ') + '"' + (attrStr ? (' ' + attrStr) : '') + '></i>';
};